import React from 'react';
import Box from '@material-ui/core/Box';
import LWTypography from 'components/common/LWTypography';
import { currency as formatUScurrency } from 'utility/format';
import Skeleton from '@liquidweb-dev/undercurrent/Skeleton';
import PropTypes from 'prop-types';
import useAssetDetails from 'modules/queries/asset/useDetails';
import useProductPrice from 'modules/queries/product/usePrice';

const pricingText = (priceData) => {
	if (priceData) {
		return priceData.month !== '0.00'
			? ` for ${formatUScurrency(priceData.month)} / month`
			: '';
	}
	return '. Price could not be calculated';
};

const PrimaryClusterable = ({ uniqId }) => {
	const { data: assetDetails } = useAssetDetails(
		{ uniq_id: uniqId, alsowith: ['region'] },
		{ enabled: Boolean(uniqId) },
	);
	const { data: priceData, isLoading: isLoadingPriceData } = useProductPrice(
		{
			code: 'DatabaseClustering.Service',
			features: {
				MES: 'DBClusteringService',
			},
			region: assetDetails?.region_id,
		},
		{ enabled: Boolean(assetDetails?.region_id) },
	);

	return (
		<>
			{isLoadingPriceData ? (
				<>
					<Box pb={3}>
						<Skeleton variant="text" width="552px" height="24px" />
						<Skeleton variant="text" width="552px" height="24px" />
					</Box>
					<Box pb={2}>
						<Skeleton variant="text" width="552px" height="24px" />
						<Skeleton variant="text" width="552px" height="24px" />
						<Skeleton variant="text" width="552px" height="24px" />
					</Box>
				</>
			) : (
				<>
					<Box pb={3}>
						<LWTypography>
							This server is compatible with a Database Clustering service
							available for this project. Since it is the first, it will be used
							as the Primary DB node.
						</LWTypography>
					</Box>
					<Box pb={2}>
						<LWTypography>
							<LWTypography bold inline>
								After added, the Database Clustering service will be enabled
								{pricingText(priceData)}.
							</LWTypography>{' '}
							The server will then be permanently tied to the service and cannot
							be removed from the project unless the server is destroyed.
						</LWTypography>
					</Box>
				</>
			)}
		</>
	);
};

PrimaryClusterable.propTypes = {
	uniqId: PropTypes.string.isRequired,
};

export default PrimaryClusterable;
